// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__1V2Xk","container":"Dialog_container__2R4tN","header":"Dialog_header__3JpdV","title":"Dialog_title__3ZoRa","closeButton":"Dialog_closeButton__1hZqR"};